module.exports = __webpack_public_path__ + "static/media/workingmemory-words-4.862d2fb3.mp3";